import { MaterialGridSizeStrict } from './types';

export const MUI_MAX_GRID_SIZE: MaterialGridSizeStrict = 12;
export const DEFAULT_ASIDE_GRID_SIZE: MaterialGridSizeStrict = 2;
export const DEFAULT_ANIMATE_DURATION = 750;
